<template>
  <div class="user-center-main" :class="{ 'collapsed': sidebarCollapsed, 'big-mode': !sidebarCollapsed, 'small-mode': sidebarCollapsed }">
    <top-bar :activeNavIdx.sync="activeNavIdx" @toggleSideBar="toggleSideBar"></top-bar>
    <side-bar :activeNavIdx.sync="activeNavIdx" text="MoName" href="MoUrl" isLeaf="IsLeaf" logo="MoLogo" groupKey="MoType" ref="sideBar"></side-bar>
    <div class="page-content">
      <div class="page-cover"></div>
      <transition name="router-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import topBar from '@/components/TopBar'
import sideBar from '@/components/SideBar'

let $body = $('body')

export default {
  name: 'Main',
  components: {
    topBar, sideBar
  },
  data() {
    return {
      sidebarCollapsed: false,
      activeNavIdx: 0
      // sideMenuData: [{
      //   text: '工程信息',
      //   href: '/ProjectInfo'
      // }, {
      //   text: '工程调试',
      //   href: '/ProjectDebug'
      // }, {
      //   text: '打印设置',
      //   href: '/PrintSetting'
      // }]
      //   sideMenuData: [{
      //   text: '工程信息',
      //   href: '/ProjectInfo'
      // }, {
      //   text: '基础数据录入',
      //   href: '/BasicDataEntry2'
      // }, {
      //   text: '收入表',
      //   href: '/Driver',
      //   children: [{
      //     text: '测试1',
      //     href: '/ProjectInfo'
      //   }, {
      //     text: '测试2',
      //     href: '/BasicDataEntry'
      //   }]
      // }, {
      //   text: '测试菜单2',
      //   href: '/test2',
      //   children: [{
      //     text: '测试2-1',
      //     href: '/test2-1'
      //   }, {
      //     text: '测试2-2',
      //     href: '/test2-2'
      //   }]
      // }, {
      //   text: '测试菜单3',
      //   href: '/test3',
      //   children: [{
      //     text: '测试3-1',
      //     href: '/test3-1'
      //   }, {
      //     text: '测试3-2',
      //     href: '/test3-2'
      //   }]
      // }, {
      //   text: '测试菜单4',
      //   href: '/test4',
      //   children: [{
      //     text: '测试4-1',
      //     href: '/test4-1'
      //   }, {
      //     text: '测试4-2',
      //     href: '/test4-2'
      //   }, {
      //     text: '测试4-3',
      //     href: '/test4-3'
      //   }]
      // }, {
      //   text: '成本表',
      //   href: '/Driver'
      // }]
    }
  },
  methods: {
    toggleSideBar() {
      if (this.sidebarCollapsed) {
        this.sidebarCollapsed = false
        $body.removeClass('collapsed')
      } else {
        this.sidebarCollapsed = true
        $body.addClass('collapsed')
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/config';
</style>



// WEBPACK FOOTER //
// Main.vue?40d49651